import ApiClient from "../ApiClient";
import NewUUID from "../../utils/randy/NewUUID";

/**
 * Fetches a single page of statements (cursor-based). Returns Promise<{ items, next_cursor }>.
 * cursor empty = first page. Limit is controlled by backend (env/config).
 */
export const fetchStatementsPage = async (csrfToken, templateId, cursor = '') => {
    let url = `/api/bills/template/${String(templateId)}/statements`;
    if (cursor) url += `?cursor=${encodeURIComponent(cursor)}`;
    const response = await ApiClient.get(url, {
        headers: {
            accept: "text/json",
            request_id: NewUUID(),
            "X-CSRF-Token": csrfToken
        },
    });
    const result = response.data.result ?? [];
    const nextCursor = response.data.next_cursor ?? '';
    return { items: result, next_cursor: nextCursor };
};

/**
 * Fetches first page of statements for a template. Returns { items, next_cursor }.
 * queryKey: ['statements', templateId, { cursor }]. cursor empty for first page. Limit from backend.
 */
export const listTemplateStatements = (csrfToken) => {
    return async ({ queryKey }) => {
        const [_, templateId, pageOpts] = queryKey;
        const cursor = pageOpts?.cursor ?? '';
        let url = `/api/bills/template/${templateId.toString()}/statements`;
        if (cursor) url += `?cursor=${encodeURIComponent(cursor)}`;
        const response = await ApiClient.get(url, {
            headers: {
                accept: "text/json",
                request_id: NewUUID(),
                "X-CSRF-Token": csrfToken
            },
        });
        const result = response.data.result ?? [];
        const nextCursor = response.data.next_cursor ?? '';
        return { items: result, next_cursor: nextCursor };
    };
};

export const addNewStatement = (csrfToken) => {
    return async (formData) => {
        try {
            const response = await ApiClient.post(
                `/api/bills/template/${formData.templateId}/statements`,
                {
                    cost: formData.cost,
                },
                {
                    headers: {
                        accept: 'application/json',
                        request_id: NewUUID(),
                        "X-CSRF-Token": csrfToken
                    },
                }
            );

            // Check if the response contains an error code
            if (response.data.code && response.data.code !== 0) {
                throw new Error(response.data.msg || 'An error occurred');
            }

            return response.data.result;
        } catch (error) {
            console.error('Error adding template statement:', error);
            console.error('Error response:', error.response);
            console.error('Error response data:', error.response?.data);
            throw error; // Re-throw the error to propagate it to the mutation
        }
    };
};
